<template>
  <div class="size1 bg0 where1-parent">
    <div
      class="size3 flex-col-sb flex-w p-l-50 p-t-25 p-b-44 respon1 reponsive-celular"
    >
      <center class="center-header-login">
        <img
          src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg"
          class="icon-login"
        />
      </center>
      <div class="p-b-9 p-t-5">
        <p class="m1-txt1 p-b-36" style="text-align: center">
          Informe os dados para gerar a cédula c
        </p>
        <form ref="formRef" class="p-grid p-fluid">
          <div
            class="wrap-input100 m-b-10 validate-input"
            data-validate="Nome requerido"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="text"
              id="matricula"
              name="matricula"
              placeholder="Matrícula"
              v-model="registro.matricula"
            />
            <span class="focus-input100"></span>
          </div>
          <div
            class="wrap-input100 m-b-10 validate-input"
            data-validate="CPF requerido"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="number"
              id="cpf"
              name="cpf"
              v-model="registro.cpf"
              placeholder="CPF sem pontos"
              maxlength="11"
              @change="getAnosBase()"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="m-b-20" style="width: 100%">
            <Dropdown
              v-model="registro.ano"
              :options="anosBase"
              placeholder="Selecione o Ano Base"
              optionLabel="item"
            />
          </div>
          <div align="center" style="width: 100%">
            <vue-recaptcha
              sitekey="6LdZS2seAAAAAGiK_ZQhvkFWIAuB9w_llxrp3lX9"
              @verify="onVerify"
              @expired="onExpired"
              ref="recaptcha"
            ></vue-recaptcha>
          </div>
          <Rotulo nome="Pensionista?" cols="12">
            <SelectButton
              v-model="registro.pensionista"
              :options="simNao"
              optionLabel="name"
              @input="getAnosBase()"
            />
          </Rotulo>
          <br />
          <div class="w-full-sm p-col-12">
            <button
              class="s2-txt2 size4 bg1 bor1 hov1 trans-04"
              type="button"
              @click="gerarPDF()"
            >
              Carregar Cédula C
            </button>
          </div>
        </form>
      </div>
      <div class="p-col-12">
        <img src="@/assets/produto-STI.png" class="img-footer-phone" />
      </div>
    </div>

    <div
      class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display"
      style=""
    >
      <!-- <div class="wsize2 flex-w flex-c-m cd100 js-tilt" style="will-change: transform; transform: perspective(300px) rotateX(0deg) rotateY(0deg);">
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('decreto')">
                    <span class="l2-txt1 p-b-9 days"><i class="pi pi-file-o"></i></span>
                    <span class="s2-txt4">Decreto de<br>Monitoramento</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('manuais')">
                    <span class="l2-txt1 p-b-9 hours"><i class="pi pi-copy"></i></span>
                    <span class="s2-txt4">Manuais e<br>Autocapacitação</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('perguntas')">
                    <span class="l2-txt1 p-b-9 minutes"><i class="pi pi-question"></i></span>
                    <span class="s2-txt4">Perguntas<br>Frequentes</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('treinamento')">
                    <span class="l2-txt1 p-b-9 seconds"><i class="pi pi-align-center"></i></span>
                    <span class="s2-txt4">Lista de<br>Treinamento</span>
                </div>
            </div> -->
    </div>

    <!-- MODAL CONFIRMA ALTERAR SENHA -->
    <cadastro-rapido
      tituloTela="ATENÇÃO!!"
      v-model="exibirTelaInfo"
      tamanhoTela="800"
      :visivelbotao="false"
      :visivelFechar="true"
    >
      <div class="p-col-12 img-centro">
        <img src="@/assets/modal_cedula_c2026.jpg" class="img-atencao" />
      </div>
    </cadastro-rapido>
    <CardExibirPDF
      v-if="pdfElement"
      v-model="exibirPDF"
      :tituloTela="'Cédula C'"
      :nomeDocumento="nomeDocumentoPDF"
      :position="'top'"
      :tamanhoTela="'80.em'"
      :alturaTela="'55.em'"
      :pdfElement="pdfElement"
    />
  </div>
</template>

<script>
import Rotulo from "@/template/RotuloSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import { baseApiUrl, simNao } from "@/config/global";
import { VueRecaptcha } from "vue-recaptcha";

export default {
  name: "cedulac-publico",
  components: { CardExibirPDF, Rotulo, CadastroRapido, VueRecaptcha },
  modoEdicao: "logar",

  data: function () {
    return {
      registro: {
        matricula: "",
        cpf: "",
        ano: "",
        pensionista: { name: "Não", code: "N" },
      },
      simNao: simNao,
      layout: "grid",
      exibirPDF: false,
      pdfElement: null,
      nomeDocumentoPDF: "cedula-c",
      anosBase: [],
      exibirTelaInfo: true,
      recaptchaWork: false,
    };
  },
  methods: {
    onVerify() {
      this.recaptchaWork = true;
    },
    onExpired: function () {
      this.recaptchaWork = false;
    },
    getAnosBase() {
      if (this.registro.pensionista == null) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Selecione a opção "Pensionista?" Sim ou Não',
          life: 4000,
        });
        return false;
      }
      var cpf = this.registro.cpf;
      var pensionista = false;
      if (this.registro.pensionista.code == "S") {
        pensionista = true;
      } else {
        pensionista = false;
      }
      var bloqueiaExercicio = true;
      this.$http
        .get(
          `${baseApiUrl}/publicos/cedulasc/anobase/${cpf}/${pensionista}/${bloqueiaExercicio}`,
        )
        .then((res) => {
          this.anosBase = res.data.map(function (item) {
            return { item: item };
          });
        });
    },
    async gerarPDF() {
      if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
        this.$store.commit("setLoader", true);
        // await this.$recaptchaLoaded()
        //const token = await this.$recaptcha('ConsultaCedulaC')
        if (this.recaptchaWork) {
          let bodyRequest = JSON.parse(JSON.stringify(this.registro));
          if (this.registro.pensionista.code == "S") {
            bodyRequest.pensionista = true;
          } else {
            bodyRequest.pensionista = false;
          }
          bodyRequest.ano = this.registro.ano.item;
          bodyRequest.bloqueiaExercicio = false;
          this.$http
            .post(
              `${baseApiUrl}/publicos/cedulasc/pdf`,
              JSON.stringify(bodyRequest),
            )
            .then((res) => {
              this.pdfElement = res.data.dadosRelatorioBase64;
              this.nomeDocumentoPDF = res.data.nomeArquivo;
              this.exibirPDF = true;
              this.registro = {
                matricula: "",
                cpf: "",
                ano: "",
                pensionista: { name: "Não", code: "N" },
              };
              this.recaptchaWork = false;
              window.grecaptcha.reset();
            });
        } else {
          this.$store.commit("setLoader", false);
          this.$toast.add({
            severity: "error",
            summary:
              "Erro ao Validar o Recaptcha, PorFavor recarregue a pagina e tente novamente",
            life: 15000,
          });
        }
      } else {
        let bodyRequest = JSON.parse(JSON.stringify(this.registro));
        if (this.registro.pensionista.code == "S") {
          bodyRequest.pensionista = true;
        } else {
          bodyRequest.pensionista = false;
        }
        bodyRequest.ano = this.registro.ano.item;
        bodyRequest.bloqueiaExercicio = false;
        this.$http
          .post(
            `${baseApiUrl}/publicos/cedulasc/pdf`,
            JSON.stringify(bodyRequest),
          )
          .then((res) => {
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;
            this.registro = {
              matricula: "",
              cpf: "",
              ano: "",
              pensionista: { name: "Não", code: "N" },
            };
            this.recaptchaWork = false;
            window.grecaptcha.reset();
          });
      }
    },
  },
};
</script>
<!-- público -->
<style scoped>
.img-centro {
  text-align: center;
}
.img-atencao {
  width: 36vw;
}
.messages-error {
  background: #ffcdd2;
  border: solid #f44336;
  border-width: 0 0 0 6px;
  color: #b71c1c;
  padding: 1rem 1.5rem;
}

.messages-info {
  background: #b3e5fc;
  border: solid #03a9f4;
  border-width: 0 0 0 6px;
  color: #01579b;
  padding: 1rem 1.5rem;
}

.imagem-fundo {
  background: url("../../assets/img-direito.png");

  background-position: 0% 45%;
  background-repeat: round;
  background-size: auto;
  height: 100.8vh;
  flex-grow: 1;
}

.img-sti {
  margin-bottom: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  width: 8%;
}

.texto-sistema {
  font-size: 20px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.logingridcontrol1 {
  background-color: #005494;
  background: url("../../assets/layout/img-login-pessoas.jpg");
  background-size: 105%;
  height: 75%;
  min-height: 75%;
}
.logingridcontrol2 {
  min-height: 75%;
  height: 75%;
  background-color: #fff;
}

.logingridcontrol2 .border {
  border: 1px dashed #005494;
  margin-top: 2px;
  border-left: 0;
  height: 100%;
}
.p-grid {
  margin-right: 0;
  margin-left: 0;
}

.loginformgvesqueci a {
  color: white;
}
.bg1 {
  background-color: #007ad9;
}
.bg2 {
  background-color: green;
}

.wrap-pic1 {
  width: 70%;
}
.bg-img1 {
  background-image: url("../../assets/cedulac.png");
}
.texto-sistema {
  font-size: 40px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.icon-login {
  width: 50%;
  margin-top: 2vw;
  margin-bottom: 4vw;
  margin-left: -2.2vw;
}
.img-top-phone {
  width: 90%;
  margin-top: 12vw;
  margin-left: -6vw;
}
.img-footer-phone {
  width: 12vw;
  margin-left: 8vw;
  margin-top: 2vw;
}
.m1-txt1 {
  font-size: 15px;
}
.s2-txt4 {
  text-transform: none;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
}
.bor2 {
  text-align: center;
  cursor: pointer;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.view-phone {
  display: none;
}
@media screen and (max-width: 40em) {
  .img-atencao {
    width: 100% !important;
  }
  .display {
    display: none !important;
  }
  .reponsive-celular {
    padding-right: 26px !important;
    padding-left: 18px !important;
  }
  .wrap-pic1 {
    width: 100%;
  }
  .view-phone {
    display: block;
  }
  .logingridcontrol1 {
    display: none;
  }
  .texto-sistema {
    margin-top: 12vw;
  }
  .img-footer-phone {
    width: 37vw;
    margin-left: 25vw;
    margin-top: 25vw;
  }
}
div.p-dropdown {
  padding: 0 22px 0 22px;
  width: 100%;
  border: 2px solid #e6e6e6;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
  line-height: 2.5;
  width: 100%;
}
</style>
